export default __webpack_public_path__ + "static/icon-512x512-884dc749caee377f74f197f1621b34e9.png";